import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const VideoContainerBox = styled(Box)<{ isFolderContainer?: boolean }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: 178,
  minWidth: 178,
  maxWidth: 178,
  flexShrink: 0,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
}))

export const VideoCardBox = styled(Box)<{ theme?: any; borderColor: string; isTranscoding?: boolean }>(
  ({ theme, borderColor, isTranscoding }) => ({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative',
    cursor: isTranscoding ? 'default' : 'pointer',
    border: `1px solid ${borderColor}`,
    height: '166px',
    width: '100%',
  }),
)

export const VideoContentBox = styled(Box)<{ backgroundColor: string }>(({ backgroundColor }) => ({
  height: '100px',
  width: '100%',
  backgroundColor,
}))

export const TranscodingBox = styled(Box)<{ backgroundColor: string }>(({ backgroundColor, theme }) => ({
  aspectRatio: '16/9',
  height: '100px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor,
  gap: theme.spacing(0.5),
}))

export const ThumbnailBox = styled(Box)<{ backgroundColor: string }>(({ backgroundColor }) => ({
  aspectRatio: '16/9',
  height: '100px',
  width: '100%',
  backgroundColor,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
}))

export const ThumbnailImage = styled('img')({
  aspectRatio: '16/9',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
})

export const PlayButtonOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
})

export const PlayButtonIconBox = styled(Box)({
  width: '24px',
  height: '24px',
  pointerEvents: 'auto',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const PopoverContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  width: 250,
}))

export const VideoInfoBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: theme.spacing(1, 1.5),
  pointerEvents: 'none',
}))
